import { Injectable, Inject } from '@angular/core';
import { indexPagesData } from 'utils/index-pages-data';

import * as _ from 'lodash';

@Injectable()
export class MyProductsStoreDataService {

  uiModel: any = {
    isHeaderFixed: false,
    isSearchFormOpened: false,
    isSortingCollapsed: true
  };
  pagesMenuData: Array<{}> = _.map(indexPagesData, (val: any, key: string) => {
    val['link'] = `my-products/${key}`;
    val['color'] = this.getCircleColor(key);
    val['visible'] = true;
    return val;
  });

  constructor(
  ) {
    this.updatePagesMenuData();
  }

  get storedMenuData(): any {
    localStorage.removeItem('myProductsMenuData2.1');
    const storedData = JSON.parse(localStorage.getItem('myProductsMenuData2.2'));
    return storedData ? storedData : null;
  }

  set storedMenuData(data: any) {
    const stringData = JSON.stringify(data);
    localStorage.setItem('myProductsMenuData2.2', stringData);
  }

  getCircleColor(link: string): string {
    switch (link) {
      case 'working':
        return 'red';
      case 'import-review-pies':
        return 'yellow';
      case 'import-review-aces':
        return 'green';
      case 'published':
        return 'lightblue';
      case 'export-review':
        return 'purple';
      case 'view-export':
        return 'darkblue';
      default:
        return 'green';
    }
  }

  updatePagesMenuData() {
    const storedData = this.storedMenuData;
    if (!storedData) {
     // if we have no stored dropdown settings - save current
     if (this.pagesMenuData) {
       this.storedMenuData = this.pagesMenuData;
     }
    } else {
     // if we have stored dropdown settings - apply them (except titles, allow)
     _.forEach(storedData, (item: any) => {
       delete item.title;
       delete item.allow;
     });
     this.pagesMenuData = _.merge(this.pagesMenuData, storedData);
    //  save an actual info
     this.storedMenuData = this.pagesMenuData;
    }
  }

  setMenuData(data: any) {
    this.pagesMenuData = data;
    this.storedMenuData = data;
  }

  setMenuItemVisibility(menuName: string, visibility: boolean) {
    const menuItem: any = _.find(this.pagesMenuData, {name: menuName});
    if (menuItem) {
      menuItem.visible = visibility;
      this.storedMenuData = this.pagesMenuData;
    }
  }

}
